/* Saber Legacy — banner de colección: emblema de gama e imagen para celular.
 *
 * Hace dos cosas, solo en Eco, Heavy Combat y Elite:
 *
 *   1. EMBLEMA. Inserta el emblema de la gama ARRIBA del bloque de texto del
 *      banner, antes del subtítulo en Aurebesh y del título.
 *
 *   2. IMAGEN PARA CELULAR. Si el banner trae DOS bloques en vez de uno,
 *      muestra el primero en escritorio y el segundo en celular. Así puedes
 *      subir una foto encuadrada para cada pantalla sin tocar código: solo
 *      duplicas el bloque en el editor de temas y le pones la otra imagen.
 *      Con un solo bloque no cambia nada.
 *
 * POR QUÉ ESTO NO ES LIQUID
 * -------------------------
 * El sitio natural sería snippets/promo-grid.liquid, justo después del <h2>
 * del bloque "advanced". Pero ese archivo pesa 24 KB y arma siete tipos de
 * bloque que se usan en toda la tienda (sale_collection, product, banner...).
 * Reescribirlo entero para insertar unas líneas es la forma clásica de romper
 * algo que no tiene nada que ver. Esto es decorativo y de presentación, así que
 * se inyecta desde aquí y el archivo del tema se queda intacto.
 *
 * El costo: aparece cuando corre el script, no en el HTML inicial. Con defer
 * son milisegundos. Si algún día se quiere en el HTML de origen, el lugar
 * exacto está anotado arriba.
 *
 * Precedente: theme.liquid ya manipula este mismo banner desde JS para marcar
 * el subtítulo en Aurebesh.
 */
(function () {
  'use strict';

  var GAMAS = {
    'eco': 'eco',
    'heavy-combat': 'heavy',
    'elite': 'elite'
  };

  /* Los emblemas son los mismos que se revisaron el 24 de agosto. Van con
     currentColor para que cambiarles el color sea una línea de CSS. */
  var TRAZO = 'fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"';

  var EMBLEMAS = {

    eco:
      '<svg viewBox="0 0 200 200" aria-hidden="true" focusable="false">' +
        '<mask id="sl-m-eco"><rect x="0" y="0" width="200" height="200" fill="#fff"/>' +
        '<rect x="86" y="46" width="28" height="99" rx="5" fill="#000"/></mask>' +
        '<g ' + TRAZO + ' stroke-width="1.8" opacity=".7" mask="url(#sl-m-eco)">' +
          '<path d="M88.89 163.03 A64 64 0 0 1 88.89 36.97"/>' +
          '<path d="M111.11 36.97 A64 64 0 0 1 111.11 163.03"/>' +
          '<circle cx="36" cy="100" r="5"/><circle cx="164" cy="100" r="5"/>' +
          '<line x1="45" y1="100" x2="57" y2="100"/><line x1="155" y1="100" x2="143" y2="100"/>' +
          '<line x1="100" y1="33" x2="100" y2="42"/><line x1="100" y1="167" x2="100" y2="158"/>' +
        '</g>' +
        '<g ' + TRAZO + ' stroke-width="2.2">' +
          '<rect x="89" y="50" width="22" height="5" rx="1"/>' +
          '<rect x="90.5" y="55" width="19" height="4"/>' +
          '<rect x="91" y="59" width="18" height="58" rx="2"/>' +
          '<circle cx="100" cy="70" r="2.8"/>' +
          '<line x1="95" y1="82" x2="95" y2="104"/><line x1="105" y1="82" x2="105" y2="104"/>' +
          '<rect x="90" y="117" width="20" height="22" rx="2"/>' +
          '<line x1="95" y1="122" x2="95" y2="134"/>' +
          '<line x1="100" y1="122" x2="100" y2="134"/>' +
          '<line x1="105" y1="122" x2="105" y2="134"/>' +
        '</g>' +
      '</svg>',

    heavy:
      '<svg viewBox="0 0 200 200" aria-hidden="true" focusable="false">' +
        '<mask id="sl-m-heavy"><rect x="0" y="0" width="200" height="200" fill="#fff"/>' +
        '<rect x="84" y="40" width="32" height="112" rx="5" fill="#000"/></mask>' +
        '<g ' + TRAZO + ' mask="url(#sl-m-heavy)">' +
          '<g stroke-width="1.6" opacity=".45">' +
            '<path d="M87.15 172.89 A74 74 0 0 1 87.15 27.11"/>' +
            '<path d="M112.85 27.11 A74 74 0 0 1 112.85 172.89"/>' +
          '</g>' +
          '<g stroke-width="2.6" opacity=".85">' +
            '<path d="M52 62 L40 74 L40 126 L52 138"/>' +
            '<path d="M148 62 L160 74 L160 126 L148 138"/>' +
            '<path d="M74 46 L86 34 L114 34 L126 46"/>' +
            '<path d="M74 154 L86 166 L114 166 L126 154"/>' +
          '</g>' +
          '<g stroke="none" fill="currentColor" opacity=".8">' +
            '<circle cx="40" cy="74" r="2.6"/><circle cx="40" cy="126" r="2.6"/>' +
            '<circle cx="160" cy="74" r="2.6"/><circle cx="160" cy="126" r="2.6"/>' +
          '</g>' +
        '</g>' +
        '<g ' + TRAZO + ' stroke-width="2.4">' +
          '<rect x="86" y="44" width="28" height="7" rx="1"/>' +
          '<rect x="88" y="51" width="24" height="5"/>' +
          '<rect x="89" y="56" width="22" height="6"/>' +
          '<rect x="88" y="62" width="24" height="60" rx="2"/>' +
          '<rect x="88" y="71" width="24" height="7"/>' +
          '<rect x="88" y="104" width="24" height="7"/>' +
          '<circle cx="100" cy="90" r="3.4"/>' +
          '<rect x="112" y="82" width="7" height="16" rx="1"/>' +
          '<rect x="86.5" y="122" width="27" height="26" rx="2"/>' +
          '<line x1="92" y1="127" x2="92" y2="143"/>' +
          '<line x1="100" y1="127" x2="100" y2="143"/>' +
          '<line x1="108" y1="127" x2="108" y2="143"/>' +
        '</g>' +
      '</svg>',

    elite:
      '<svg viewBox="0 0 200 200" aria-hidden="true" focusable="false">' +
        '<mask id="sl-m-elite"><rect x="0" y="0" width="200" height="200" fill="#fff"/>' +
        '<rect x="83" y="34" width="34" height="134" rx="5" fill="#000"/></mask>' +
        '<g ' + TRAZO + ' stroke-width="1.7" opacity=".75" mask="url(#sl-m-elite)">' +
          '<path d="M86.46 176.82 A78 78 0 0 1 86.46 23.18"/>' +
          '<path d="M113.54 23.18 A78 78 0 0 1 113.54 176.82"/>' +
          '<path d="M88.54 165.00 A66 66 0 0 1 88.54 35.00"/>' +
          '<path d="M111.46 35.00 A66 66 0 0 1 111.46 165.00"/>' +
          '<path d="M90.62 153.18 A54 54 0 0 1 90.62 46.82"/>' +
          '<path d="M109.38 46.82 A54 54 0 0 1 109.38 153.18"/>' +
          '<circle cx="100" cy="100" r="42" stroke-dasharray="3 6"/>' +
          '<circle cx="100" cy="22" r="6"/><circle cx="178" cy="100" r="6"/>' +
          '<circle cx="100" cy="178" r="6"/><circle cx="22" cy="100" r="6"/>' +
          '<circle cx="155.15" cy="44.85" r="3.4"/><circle cx="155.15" cy="155.15" r="3.4"/>' +
          '<circle cx="44.85" cy="155.15" r="3.4"/><circle cx="44.85" cy="44.85" r="3.4"/>' +
          '<line x1="31" y1="100" x2="44" y2="100"/><line x1="169" y1="100" x2="156" y2="100"/>' +
          '<line x1="100" y1="31" x2="100" y2="40"/><line x1="100" y1="169" x2="100" y2="160"/>' +
          '<g stroke-width="1.4" opacity=".55">' +
            '<line x1="128.5" y1="30.6" x2="125.5" y2="37.9"/>' +
            '<line x1="169.4" y1="71.5" x2="162.1" y2="74.5"/>' +
            '<line x1="169.4" y1="128.5" x2="162.1" y2="125.5"/>' +
            '<line x1="128.5" y1="169.4" x2="125.5" y2="162.1"/>' +
            '<line x1="71.5" y1="169.4" x2="74.5" y2="162.1"/>' +
            '<line x1="30.6" y1="128.5" x2="37.9" y2="125.5"/>' +
            '<line x1="30.6" y1="71.5" x2="37.9" y2="74.5"/>' +
            '<line x1="71.5" y1="30.6" x2="74.5" y2="37.9"/>' +
          '</g>' +
        '</g>' +
        '<g ' + TRAZO + ' stroke-width="2.2">' +
          '<rect x="85" y="38" width="30" height="7" rx="1"/>' +
          '<rect x="87" y="45" width="26" height="5"/>' +
          '<rect x="88.5" y="50" width="23" height="4"/>' +
          '<rect x="90" y="54" width="20" height="5"/>' +
          '<rect x="88" y="59" width="24" height="72" rx="2"/>' +
          '<circle cx="100" cy="70" r="3.2"/><circle cx="100" cy="70" r="6.2"/>' +
          '<rect x="95.5" y="84" width="9" height="18" rx="4.5"/>' +
          '<rect x="95.5" y="106" width="9" height="16" rx="4.5"/>' +
          '<rect x="112" y="84" width="7" height="13" rx="1"/>' +
          '<rect x="112.5" y="100" width="5" height="7" rx="1"/>' +
          '<line x1="91" y1="82" x2="91" y2="128"/><line x1="109" y1="82" x2="109" y2="128"/>' +
          '<rect x="87" y="131" width="26" height="26" rx="2"/>' +
          '<line x1="92" y1="136" x2="92" y2="152"/>' +
          '<line x1="96.5" y1="136" x2="96.5" y2="152"/>' +
          '<line x1="101" y1="136" x2="101" y2="152"/>' +
          '<line x1="105.5" y1="136" x2="105.5" y2="152"/>' +
          '<line x1="110" y1="136" x2="110" y2="152"/>' +
          '<path d="M89 157 L100 165 L111 157"/>' +
        '</g>' +
      '</svg>'
  };

  function estilos() {
    if (document.getElementById('sl-emblema-estilo')) return;
    var s = document.createElement('style');
    s.id = 'sl-emblema-estilo';
    s.textContent =
      '.sl-emb{margin:0 auto 18px;line-height:0}' +
      '.sl-emb svg{width:120px;height:120px;display:block;margin:0 auto;' +
        'color:#05dfd7;opacity:.92}' +
      '@media(max-width:768px){.sl-emb{margin-bottom:14px}' +
        '.sl-emb svg{width:84px;height:84px}}' +
      /* Dos bloques en el banner = una imagen por pantalla. */
      '@media(max-width:768px){.sl-ban--desk{display:none !important}}' +
      '@media(min-width:769px){.sl-ban--mob{display:none !important}}';
    document.head.appendChild(s);
  }

  function gama() {
    var m = window.location.pathname.match(/\/collections\/([^\/?#]+)/);
    if (!m) return null;
    return GAMAS[m[1].toLowerCase()] || null;
  }

  /* Si el banner trae exactamente dos bloques, el primero es el de escritorio
     y el segundo el de celular. Con uno o con tres o más no se toca nada: no
     hay forma de adivinar la intención y es mejor no romper un diseño. */
  function repartir() {
    var items = document.querySelectorAll('.promo-grid .flex-grid > .flex-grid__item');
    if (items.length !== 2) return;
    items[0].classList.add('sl-ban--desk');
    items[1].classList.add('sl-ban--mob');
  }

  function poner() {
    var cual = gama();
    if (!cual) return;

    estilos();
    repartir();

    /* El emblema va en CADA bloque del banner: con dos bloques, cada uno tiene
       su propio título y solo uno se ve a la vez.

       15 sep 2026: antes iba justo DEBAJO del <h2>. Ahora va arriba de todo el
       bloque de texto. No se metió entre el subtítulo en Aurebesh y el título
       porque esos dos son una pareja tipográfica — el subtítulo es el antetítulo
       del <h2> — y partirlos a la mitad rompe la lectura. Arriba funciona como
       escudo sobre el nombre de la gama. */
    var titulos = document.querySelectorAll('.promo-grid__content .promo-grid__text h2');

    for (var i = 0; i < titulos.length; i++) {
      var bloque = titulos[i].parentElement;
      if (!bloque) continue;
      if (bloque.firstElementChild && bloque.firstElementChild.classList.contains('sl-emb')) continue;

      var caja = document.createElement('div');
      caja.className = 'sl-emb';
      /* Los id de las máscaras se hacen únicos por copia. Dos SVG con el mismo
         id en la página hacen que la segunda máscara apunte a la primera. */
      caja.innerHTML = EMBLEMAS[cual].replace(/sl-m-([a-z]+)/g, 'sl-m-$1-' + i);
      bloque.insertAdjacentElement('afterbegin', caja);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', poner);
  } else {
    poner();
  }

  /* El editor de temas vuelve a pintar la sección sin recargar la página. */
  document.addEventListener('shopify:section:load', poner);
})();
